/*Tps-report*/
if (window.location.pathname.includes("crm/contact/")) {
    setTimeout(() => {
        const data = window.app_data.contact.manager;

        if (!data) return;

        const [company] = data ? data.companies : [];
        const companyName = company ? " (" + company.name + ")" : "";
        $('select[name="manager_id"]')
            .append('<option value="' + data.id + '">' + data.name + companyName + '</option>')
            .val(data.id.toString());

        $('[name="manager_email"]').val(data.email);
        $('[name="manager_phone"]').val(data.phone);
    }, 500);

    function handleChildCollapse (e) {
        const tr = $(e.target.closest('tr'));

        if (tr.hasClass('shown')) {
            $(this).find('i').addClass('fa-caret-right');
            $(this).find('i').removeClass('fa-caret-down');
            tr.removeClass('shown');
        } else {
            $(this).find('i').removeClass('fa-caret-right');
            $(this).find('i').addClass('fa-caret-down');
            tr.addClass('shown');
        }
    }

    $(window).on('tableLoaded', function (event, table) {
        if ($(table).hasClass('table-branches')) {
            table.off('click', '> tbody > tr > td > button.dt-collapse');
            table.on('click', '> tbody > tr > td > button.dt-collapse', handleChildCollapse);
            table.DataTable().rows().every( function () {
                const data = this.data();
                const rowId = data.id;

                if (!data.contact_count) return;

                this.child(`<div class="ml-5 bg-white"><table data-dom="rtp" id="manager-contacts-table-${rowId}" class="data-table table-managers w-100" data-id="contact_editor"
                    data-select="true"
                    data-command_pre='[{"icon": "fas fa-file-alt", "type": "placements"}]'
                    data-action="/api/admin/contacts?no_cache=true&managers=true"
                    data-unassign-contact="/api/company/unassign_contact"
                    data-assign-contact="adjusters"
                    data-office_id="${rowId}"
                    data-post_data='${JSON.stringify({ "office_id": rowId })}'>
                    <thead>
                        ${Object.keys(window.app_data.datatables.contacts.header).map((k) => `<td data-column="${k}">${window.app_data.datatables.contacts.header[k]}</td>`).join("")}
                    </thead>
                </table></div>`).show();

                $("#manager-contacts-table-" + rowId).data("options", app_data.datatables.contacts.options);
                window.dataTableInstance($("#manager-contacts-table-" + rowId));
            });

            $('#associated-offices-search').append('<input type="search" class="form-control form-control-sm" placeholder="Search">');
        }

        if ($(table).hasClass('table-managers') || $(table).hasClass('table-adjusters') || $(table).hasClass('table-subadjusters')) {
            table.off('click', '> tbody > tr > td > button.dt-collapse');
            table.on('click', '> tbody > tr > td > button.dt-collapse', handleChildCollapse);
            table.DataTable().rows().every( function () {
                const prefixId = $(table).hasClass('table-managers') ? 'adjuster-contacts-table-' : 'subadjuster-contacts-table-';
                const tableClass = $(table).hasClass('table-managers') ? 'table-adjusters' : 'table-subadjusters';
                const data = this.data();
                const rowId = data.id;

                if (!data.contact_count) return;

                this.child(`<div class="ml-5 bg-white"><table data-dom="rtp" id="${prefixId}${rowId}" class="data-table table-no-headers ${tableClass} w-100" data-id="contact_editor"
                    data-select="true"
                    data-command_pre='[{"icon": "fas fa-file-alt", "type": "placements"}]'
                    data-unassign-contact="/api/company/unassign_contact"
                    data-action="/api/admin/contacts?no_cache=true&adjusters=true&manager_id=${rowId}">
                    <thead>
                        ${Object.keys(window.app_data.datatables.contacts.header).map((k) => `<td data-column="${k}">${window.app_data.datatables.contacts.header[k]}</td>`).join("")}
                    </thead>
                </table></div>`).show();

                $("#" + prefixId + rowId).data("options", app_data.datatables.contacts.options);
                window.dataTableInstance($("#" + prefixId + rowId));
            });
        }
    });

    $(window).on("/api/company/assign_contact.success", (e, response, form) => {
        popup_close("editor-assign_contact-" + app_data.assign_contact.type);

        if (app_data.assign_contact.type === 'offices') {
            const tableMain = $("#branches-table");
            tableMain.DataTable().destroy();
            window.dataTableInstance(tableMain);
        } else {
            const table = $("#" + app_data.assign_contact.table_id);
            table.DataTable().destroy();
            window.dataTableInstance(table);
        }

        window.app_data.assign_contact.type = null;
        window.app_data.assign_contact.office_id = null;
        window.app_data.assign_contact.manager_id = null;
        window.app_data.assign_contact.is_manager = false;
    });

    $(window).on("/api/company/unassign_contact.success", (e, response, form) => {
        const tableMain = $("#branches-table");
        tableMain.DataTable().destroy();
        window.dataTableInstance(tableMain);
    });

    $(window).on("/api/company/unassign.success", (e, response, form) => {
        const tableMain = $("#branches-table");
        tableMain.DataTable().destroy();
        window.dataTableInstance(tableMain);
    });

    $(window).on("/api/contact/update.success", function(e, response){
        const data = response.original.manager;

        if (data) {
            $('[name="manager_email"]').val(data.email);
            $('[name="manager_phone"]').val(data.phone);
        }
    });

    $(window).on("/api/note/create.success", function(e, response, form){
        form[0].reset();
        $('select[name="note_type_id"]').val('').trigger('change').trigger('change');
        $('select[name="status"]').val('').trigger('change').trigger('change');
        window.app_data.leave_note = '';
        app.contact.notes.unshift(response['note']);
    });

    $(document).on("click", ".sync-contact", function(e){
        e.preventDefault();

        $(this).popover({
            "placement":"left",
            "template":popover_templates.confirm,
            "title":"Sync data?",
            "content":"Sync data to active placements?",
            "delay":{"show":0, "hide":250}
        }).popover("show");
    });

    $(window).on("confirm.bs.popover", function(e, popover, confirm){
        const ele = $(popover.element);
        const id = ele.data('id');
        if(confirm && ele.hasClass("sync-contact")) {
            $.ajax({
              url: `/api/contact/${id}/sync`,
              method: "POST",
              data: {},
              dataType: "json",
              success: function(response){
                if (response.message) {
                  message(response.message);
                }
              }
            });
        }

        ele.popover("dispose");
    });

    $("#branches-table").data("options", app_data.datatables.branches.options);
    $("#placements-table").data("options", app_data.datatables.placements.options);
    $("#frv-table").data("options", app_data.datatables.frv.options);
    $("#hotel-table").data("options", app_data.datatables.hotel.options);
    $("#lost-table").data("options", app_data.datatables.lost.options);

    $(document).on("click", '.datatable-command[data-type="placements"]', function(e) {
        popup_open("editor-adjuster_placements", {
            contact_id: $(this).data("id"),
        });
    });

    $('.data-table.history-table').data('options', {
        ordering: false,
        responsive: false,
        scrollX: true,
        columnDefs: [
            {
                render: function (data, type, row) {
                    if (row.company_id) {
                        return row.company.name;
                    }
                    return row.company_data.name;
                },
                target: 0
            },
            {
                render: function (data, type, row) {
                    return row.address_data.address;
                },
                target: 1
            },
            {
                render: function (data, type, row) {
                    return row.address_data.city;
                },
                target: 2
            },
            {
                render: function (data, type, row) {
                    return row.address_data.state;
                },
                target: 3
            },
            {
                render: function (data, type, row) {
                    return row.address_data.zip;
                },
                target: 4
            }
        ]
    });

    $(window).on("popup_open", function(e, type, data) {
        if (type === "editor-adjuster_placements") {
            editPopupIsOpen = true;
            window.app_data.viewing_contact_id = data.contact_id;
            window.reinitCrmTable(window.app_data.datatables.placements, ".table-placements", "placement", data.contact_id);
            window.reinitCrmTable(window.app_data.datatables.frv, ".table-frv", "frv", data.contact_id);
            window.reinitCrmTable(window.app_data.datatables.hotel, ".table-hotel", "hotel", data.contact_id);
            window.reinitCrmTable(window.app_data.datatables.hold, ".table-hold", "hold", data.contact_id);
            window.reinitCrmTable(window.app_data.datatables.lost, ".table-lost", "lost", data.contact_id);
        }
    });

    $(window).on('popup_open', function (e, type, data) {
        if (type === 'editor-crm_alerts' && typeof data !== 'undefined') {
            if (!data.isEdit) return;

            const pop = $('.popup[data-type="editor-crm_alerts"]');

            if (!data.response) return;

            pop.find('[name="user_id"]')
                .append('<option value="' + data.response.user.id + '">' + data.response.user.name + '</option>')
                .val(data.response.user_id.toString())
                .trigger("change")
                .trigger("change");
            pop.find('[name="alert_template_id"]')
                .append('<option value="' + data.response.template.id + '">' + data.response.template.name + '</option>')
                .val(data.response.alert_template_id.toString())
                .trigger("change")
                .trigger("change");
        }
    });

    const alert_options = {
        "columnDefs": [
            {
                targets: 0,
                createdCell: function (td, cellData, rowData, row, col) {
                    if (moment(row.reminder_date).isBefore(moment())) {
                        $(td).css('background-color', '#f5c6cb');
                    }
                }
            },
        ]
    };

    $('#crm_alerts').data('options', alert_options);

    $(window).on("/api/alert/create.success", function(e, response) {
        const table = $("#crm_alerts");
        table.DataTable().destroy();
        table.data("options", alert_options);
        window.dataTableInstance(table);
    });
    

    const handleContactSearch = _.debounce(function () {
        const searchValue = $(this).val();

        $(".associated-offices-wrapper .table-branches").each(function () {
            handleChildSearch(searchValue, $(this), '.table-managers');
        });

        tableRedraw($('.table-placements'), searchValue);
        tableRedraw($('.table-frv'), searchValue);
        tableRedraw($('.table-hotel'), searchValue);
        tableRedraw($('.table-hold'), searchValue);
    }, 100);

    const handlePlacementSearch = _.debounce(function () {
        const searchValue = $(this).val();

        tableRedraw($('.table-placements'), searchValue);
        tableRedraw($('.table-frv'), searchValue);
        tableRedraw($('.table-hotel'), searchValue);
        tableRedraw($('.table-hold'), searchValue);
    }, 100);

    function handleChildSearch (searchValue, table, childClass) {
        const rows = table.DataTable().rows();

        rows.every(function () {
            const row = $(this.node());

            if (row.hasClass('dt-hasChild')) {
                const data = this.data();
                const childTable = this.child().find(childClass);
                const nextClass = childClass === '.table-managers' ? '.table-adjusters' : '.table-subadjusters';

                if (childTable && childTable.find(nextClass)) {
                    handleChildSearch(searchValue, childTable, nextClass);
                }

                tableRedraw(childTable, searchValue);
                const info = childTable.DataTable().page.info();

                if (info && info.recordsDisplay) {
                    data.searchableValue = searchValue;
                } else {
                    tableRedraw(table.find(childClass), '');
                }

                this.data(data);
            }
        });

        tableRedraw(table, searchValue);
    }

    function tableRedraw(table, search = false) {
        const tableInstance = table.DataTable();
        if (search !== false) {
            tableInstance.search(search).draw();
        } else {
            tableInstance.columns.adjust().draw();
        }
    }

    $(document).on("keyup", "input[name='search_contacts']", handleContactSearch);
    $(document).on("keyup", "input[name='search_placements']", handlePlacementSearch);
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/admin/contact.js